import React, { useState } from 'react';
import AdminPreAuthLayout from '../layouts/AdminPreAuthLayout';
import PreAuthCard from '../../shared/components/PreAuthCard';
import FormInput from '../../shared/components/FormInput';
import IconButton from '../../shared/components/IconButton';
import { useLocation } from 'react-router-dom';
import { API_URL } from '../../config/env';

export default function PasswordResetRequestPage() {
  const location = useLocation();
  const prefillEmail = location.state?.email || '';
  const [email, setEmail] = useState(prefillEmail);
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setSubmitting(true);

    try {
      const res = await fetch(`${API_URL}/v1/admin/users/password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user: { email } }),
      });

      if (!res.ok) {
        throw new Error('We could not send a reset email for that address.');
      }
      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AdminPreAuthLayout>
      <PreAuthCard>
        <div className="text-center mb-3">
          <h1 className="fs-4 fw-semibold mb-1">Forgot your password?</h1>
          <p className="text-muted mb-0">
            Enter your email to receive a password reset link.
          </p>
        </div>

        {error && <div className="alert alert-danger py-2 small">{error}</div>}
        {success && <div className="alert alert-success py-2 small">Check your email for a reset link.</div>}

        <form onSubmit={handleSubmit} autoComplete="on">
          <FormInput
            id="reset-email"
            name="email"
            label="Email address"
            type="email"
            placeholder="you@company.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            icon="bi-envelope-fill"
            autoComplete="username"
            disabled={submitting}
            inputClassName="py-3 rounded-3 border fw-medium"
            required
          />

          <IconButton
            type="submit"
            className="btn btn-primary w-100 py-3 fw-bold"
            icon="bi-arrow-right"
            disabled={submitting}
          >
            Send reset link
          </IconButton>
        </form>
      </PreAuthCard>
    </AdminPreAuthLayout>
  );
}
